<div *ngFor="let noteSection of noteSections">
  <div [ngClass]="noteSection.noteClass" class="mt-10 mb-10" role="alert">
    <i [ngClass]="noteSection.iconClass || ''" class="redWarningIcon"></i>
    <strong> {{ noteSection.title }}</strong>
    <span class="pl-2" [innerHTML]="noteSection.body || '' | mdToHtml"></span>
  </div>
</div>
